module.exports = __webpack_public_path__ + "media/images/num3_ic-on-e35baa60294cafe625d79a036b8cafd3.svg";